import { MetaDataType, createCustomFieldDTO } from "../../../entities/IMetaData";

export const processCustomFieldPayload = (payload: createCustomFieldDTO): createCustomFieldDTO => {
  const { options, required, ...newPayload } = payload;

  const base = { ...newPayload, required: required ?? false };

  if (payload.dataType === MetaDataType.SELECT && options) {
    return { ...base, options } as createCustomFieldDTO;
  }
  return base as createCustomFieldDTO;
};
